'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _bound = require('./utils/bound');

var _bound2 = _interopRequireDefault(_bound);

var _Tab = require('./Tab');

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 */
function makeDefaultTabId(id, name) {
	return id + '-tab-' + name;
}

/**
 *
 */
function makeDefaultPanelId(id, name) {
	return id + '-panel-' + name;
}

/**
 *
 */
var Tabs = (_temp = _class = function (_Component) {
	_inherits(Tabs, _Component);

	/**
  *
  */


	/**
  *
  */
	function Tabs(props) {
		_classCallCheck(this, Tabs);

		var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

		(0, _lodash.bindAll)(_this, 'handleActive', 'handlePrevious', 'handleNext');

		_this.id = (0, _lodash.uniqueId)('rea11y-');
		return _this;
	}

	/**
  *
  */


	/**
  *
  */


	_createClass(Tabs, [{
		key: 'componentDidUpdate',
		value: function componentDidUpdate(previousProps) {
			if (previousProps.active !== this.props.active) {
				var active = this.refs[this.props.active];
				(0, _reactDom.findDOMNode)(active).focus();
			}
		}

		/**
   *
   */

	}, {
		key: 'tabNames',
		value: function tabNames() {
			return _react.Children.map(this.props.children, function (child) {
				return child.props.name;
			});
		}

		/**
   *
   */

	}, {
		key: 'activateSibling',
		value: function activateSibling(name, direction) {
			var names = this.tabNames();
			var index = names.indexOf(name) + direction;
			var max = names.length - 1;
			var sibling = (0, _bound2.default)(index, 0, max, true);

			this.emitActive(names[sibling]);
		}

		/**
   *
   */

	}, {
		key: 'emitActive',
		value: function emitActive(name) {
			if (this.props.active !== name) {
				this.props.onActive(name);
			}
		}

		/**
   *
   */

	}, {
		key: 'handleActive',
		value: function handleActive(name) {
			this.emitActive(name);
		}

		/**
   *
   */

	}, {
		key: 'handlePrevious',
		value: function handlePrevious(name) {
			this.activateSibling(name, -1);
		}

		/**
   *
   */

	}, {
		key: 'handleNext',
		value: function handleNext(name) {
			this.activateSibling(name, 1);
		}

		/**
   *
   */

	}, {
		key: 'renderTabs',
		value: function renderTabs() {
			var _this2 = this;

			var _props = this.props;
			var active = _props.active;
			var makeTabId = _props.makeTabId;
			var makePanelId = _props.makePanelId;
			var children = _props.children;


			return _react.Children.map(children, function (child) {
				var _child$props = child.props;
				var name = _child$props.name;
				var title = _child$props.title;


				return _react2.default.createElement(_Tab2.default, {
					key: name,
					ref: name,
					id: makeTabId(_this2.id, name),
					panelId: makePanelId(_this2.id, name),
					name: name,
					title: title,
					active: active === name,
					onActive: _this2.handleActive,
					onPrevious: _this2.handlePrevious,
					onNext: _this2.handleNext
				});
			});
		}

		/**
   *
   */

	}, {
		key: 'renderPanels',
		value: function renderPanels() {
			var _this3 = this;

			var _props2 = this.props;
			var active = _props2.active;
			var makeTabId = _props2.makeTabId;
			var makePanelId = _props2.makePanelId;
			var children = _props2.children;


			return _react.Children.map(children, function (child) {
				var name = child.props.name;


				return (0, _react.cloneElement)(child, {
					key: name,
					active: active === name,
					id: makePanelId(_this3.id, name),
					tabId: makeTabId(_this3.id, name)
				});
			});
		}

		/**
   *
   */

	}, {
		key: 'render',
		value: function render() {
			var className = (0, _classnames2.default)('rea11y-Tabs', 'rea11y-Tabs--' + this.props.orientation);

			return _react2.default.createElement(
				'div',
				{ className: className },
				_react2.default.createElement(
					'div',
					{ className: 'rea11y-Tabs-tabList', role: 'tablist' },
					this.renderTabs()
				),
				_react2.default.createElement(
					'div',
					{ className: 'rea11y-Tabs-panelList' },
					this.renderPanels()
				)
			);
		}
	}]);

	return Tabs;
}(_react.Component), _class.propTypes = {
	orientation: _react.PropTypes.string,
	active: _react.PropTypes.string,
	onActive: _react.PropTypes.func,
	makeTabId: _react.PropTypes.func,
	makePanelId: _react.PropTypes.func,
	children: _react.PropTypes.any.isRequired
}, _class.defaultProps = {
	orientation: 'horizontal',
	makeTabId: makeDefaultTabId,
	makePanelId: makeDefaultPanelId
}, _temp);
exports.default = (0, _recompose.pure)(Tabs);